export const ICON_FEATURE_GRID_CARD_TEST_ID = {
  gridCell: 'grid-cell',
};
